import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';

import { Advantages } from '../../components/Advantages';
import { HOMEOWNER_ADVANTAGES_ITEMS } from '../../components/Advantages/utils/constants';
import { FAQ } from '../../components/FAQ';
import { HowItWork } from '../../components/HowItWork';
import { homeownerContent } from '../../components/HowItWork/constants';
import { Layout } from '../../components/Layout';
import { VIEWED_TIMEOUT } from '../../constants/timeouts';
import { useTeaserTracking } from '../../hooks/useTeaserTracking';
import { IScrollRef } from '../../types/page/scrolling';

export const HomeownerPage: React.FC<IScrollRef> = ({ howItWorkRef }) => {
  const { trackShowAdvantages, trackShowFAQ, trackShowSteps } = useTeaserTracking();

  return (
    <Layout>
      <ActionAfterViewObserver callback={trackShowAdvantages} callbackDelay={VIEWED_TIMEOUT}>
        <Advantages testId="HomeownerAdvantages" heading="Чем он лучше обычного" items={HOMEOWNER_ADVANTAGES_ITEMS} />
      </ActionAfterViewObserver>

      <ActionAfterViewObserver callback={trackShowFAQ} callbackDelay={VIEWED_TIMEOUT}>
        <FAQ />
      </ActionAfterViewObserver>

      <ActionAfterViewObserver callback={trackShowSteps} callbackDelay={VIEWED_TIMEOUT}>
        <HowItWork content={homeownerContent} howItWorkRef={howItWorkRef} />
      </ActionAfterViewObserver>
    </Layout>
  );
};
